// extracted by mini-css-extract-plugin
export var colorSquare = "_kg-0";
export var danger = "_kg-5";
export var lightPink = "_kg-8";
export var neutralBlue = "_kg-7";
export var neutralYellow = "_kg-6";
export var normal = "_kg-1";
export var primary = "_kg-2";
export var primaryLight = "_kg-3";
export var solidBlack = "_kg-g";
export var solidGreen = "_kg-b";
export var solidLightBlue = "_kg-d";
export var solidNavy = "_kg-c";
export var solidOrange = "_kg-f";
export var solidPink = "_kg-e";
export var solidRed = "_kg-9";
export var solidYellow = "_kg-a";
export var success = "_kg-4";